import { Slot } from '@radix-ui/react-slot';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import { Button } from '@repo/ui/Button';
import { useDialog } from '@repo/ui/Dialog/DialogRoot';

export type DialogCloseProps = ComponentPropsWithRef<'button'> & {
  asChild?: boolean;
  className?: string;
  children?: ReactNode;
};

export const DialogClose = (props: DialogCloseProps) => {
  const { asChild, children, className = 'Close', onClick, ...attrs } = props;
  const { close } = useDialog();

  const handleClick: ComponentPropsWithRef<'button'>['onClick'] = async (e) => {
    if (onClick) {
      const result = await onClick(e);

      if (typeof result === 'boolean' && result === false) {
        return;
      }
    }

    close();
  };

  const Component = asChild ? Slot : Button;

  return (
    <Component className={className} onClick={handleClick} {...attrs}>
      {children}
    </Component>
  );
};
